import React from "react";

export const SessionRestore: React.FC = () => {
	localStorage.removeItem("accessToken");
	localStorage.removeItem("refreshToken");

	const awsToken = new URLSearchParams(window.location.search).get("awsToken");
	const refreshToken = new URLSearchParams(window.location.search).get("refreshToken");
	const redirect = new URLSearchParams(window.location.search).get("redirect");
	const tab = new URLSearchParams(window.location.search).get("tab");

	const currentAccessToken = localStorage.getItem("accessToken");
	const currentRefreshToken = localStorage.getItem("refreshToken");

	if (currentAccessToken && currentRefreshToken) {
		window.location.href = "/";
		return;
	}

	if (!awsToken || !refreshToken) {
		window.location.href = "/guest";

		return;
	}

	localStorage.setItem("accessToken", awsToken);
	localStorage.setItem("refreshToken", refreshToken);

	let redirectUrl = `/${redirect}`;

	if (tab) {
		redirectUrl += `/${tab}`;
	}

	if (redirect) {
		window.location.href = redirectUrl;

		return null;
	}

	window.location.href = "/";
};
